export const passportTypes = ['Ordinary', 'Diplomatic', 'Official/Service ', 'Laissez-passer'];
export const tourist_visa_slug = 'tourist-visa';
export const transit_visa_slug = 'transit-visa';
export const NEPALIPORT_LOGO_URL = 'https://cdn01.immigration.gov.np/public/images/tourist/nepaliport_logo.png';
export const NEPAL_SARKAR_LOGO = 'https://cdn01.immigration.gov.np/public/images/nepal_sarkar.png'
export const VISA_PLANS = [{
    key: 1,
    value: 'Plain'
}, {
    key: 2,
    value: 'Single reentry'
}, {
    key: 3,
    value: 'Multiple reentry'
}
];

// 0 => 'Main Office',
//     1 => 'Branch Office',
//     2 => 'Airport',
//     3 => 'Border',
//     4 => 'Embassy',
//     5 => 'Government Institution'
export const MAIN_OFFICE = 0;
export const BRANCH_OFFICE = 1;
export const AIRPORT = 2;
export const BORDER = 3;
export const EMBASSY = 4;
export const CONSULATE_GENERAL = 6;
export const MISSION = 7;
export const GOVERNMENT_INSTITUTION = 5;